import { useEffect, useState, useCallback } from 'react'

interface UseMidnightTriggerOptions {
  onMidnight?: () => void
  enabled?: boolean
}

export const useMidnightTrigger = (options: UseMidnightTriggerOptions = {}) => {
  const { onMidnight, enabled = true } = options
  const [currentDate, setCurrentDate] = useState(new Date().toDateString())
  const [midnightCount, setMidnightCount] = useState(0)

  const triggerMidnightUpdate = useCallback(() => {
    const newDate = new Date().toDateString()
    setCurrentDate(newDate)
    setMidnightCount((prev) => prev + 1)

    if (onMidnight) {
      onMidnight()
    }
  }, [onMidnight])

  useEffect(() => {
    if (!enabled) return

    const setupMidnightTimer = () => {
      const now = new Date()
      const tomorrow = new Date(now)
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0)

      const msUntilMidnight = tomorrow.getTime() - now.getTime()

      // Set timeout for first midnight
      const timeoutId = setTimeout(() => {
        triggerMidnightUpdate()

        // Set up recurring midnight updates (every 24 hours)
        const intervalId = setInterval(
          () => {
            triggerMidnightUpdate()
          },
          24 * 60 * 60 * 1000
        )

        // Store interval ID for cleanup
        return () => clearInterval(intervalId)
      }, msUntilMidnight)

      return () => clearTimeout(timeoutId)
    }

    const cleanup = setupMidnightTimer()

    return cleanup
  }, [enabled, triggerMidnightUpdate])

  return {
    currentDate,
    midnightCount,
    triggerMidnightUpdate
  }
}
